import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function OrderReceipt({ receiptData }) {
  const { t, i18n } = useTranslation();
  const userData = useSelector((state) => state?.login?.user?.result);
 const isETAenabled = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_eta_enabled
  );
  const renderProductLines = () => {
  return receiptData?.order[0]?.products_lines.flatMap((item, index) => {
    const discountAmount = Number(item?.discount_amount || 0);
    const totalProductPrice = Number(item.price_unit * item.qty || 0) + (isETAenabled ? (item.qty > 0 ? item?.tax_amount : -item?.tax_amount) : 0)
    return [
      // ✅ Product row
      <tr key={`product-${index}`}>
        {/* <td className="text-center align-top">{index + 1}</td> */}

        <td className={i18n.language === "ar" ? "text-right" : "text-left"}>
          {item.name}
        </td>

        <td className="text-center">
          {i18n.language === "ar"
            ? item.qty >= 0
              ? `${item.qty}`
              : `${Math.abs(item.qty)}-`
            : item.qty}
        </td>

        <td className="text-center">
          {Number(item.price_unit).toFixed(2)}
        </td>

                {/* ✅ TAX COLUMN */}
                {isETAenabled && 
                   <td className="text-center">
          {item?.tax_rate_percent}%
        </td>
                }
     


        <td className="text-right">
          {i18n.language === "ar"
            ? Number(totalProductPrice) >= 0
              ? Number(totalProductPrice).toFixed(2)
              : `${Math.abs(Number(totalProductPrice)).toFixed(2)}-`
            : Number(totalProductPrice).toFixed(2)}
        </td>
      </tr>,

      // ✅ Discount row (same size & color as product)
      discountAmount > 0 && (
        <tr key={`discount-${index}`}>
          <td></td>

          <td
             colSpan={isETAenabled ? 3 : 2}
            className={i18n.language === "ar" ? "text-right" : "text-left"}
          >
            {t("Discount applied")}
          </td>

          <td className="text-right" dir="ltr">
            -{discountAmount.toFixed(2)}
          </td>
        </tr>
      ),
    ];
  });
};

  let order_id = receiptData?.order[0]?.order_no;
  let order_idChange = order_id?.replace(/\s/g, "%20");
  let Change = 0;
  let Cash;
  let PaymentMethod = "";
  let PaymentMethodLine = "";
const isReturnOrder = receiptData?.order?.[0]?.products_lines?.some(
  (line) => Number(line?.qty) < 0
) || false;
  //   console.log("pdatatata--->",userData?.company_name_ar )

  receiptData?.order[0]?.payment_data.forEach((item) => {
    if (item?.name == "return") {
      Change = item?.amount;
    }
    if (item?.payment_method === "Bank" || item.payment_method === "بنك") {
      Change = 0;
      Cash = item?.amount;
      console.log("1");
    }
    if (item?.payment_method === "Cash" || item.payment_method === "نقد") {
      Cash = item?.amount;
      Change = (Cash - receiptData.order[0].order_value).toFixed(2);
      console.log("2");
    }
    if (
      item?.payment_method === "Credit Card" ||
      item.payment_method === "بطاقة إئتمان"
    ) {
      Cash = item?.amount;
      Change = 0;
      console.log("3");
    }
    if (
      item?.payment_method === "InstaPay" ||
      item.payment_method === "إنستاباي"
    ) {
      Cash = item?.amount;
      Change = 0;
      console.log("4");
    }
    if (
      item?.name == false &&
      (item?.payment_method === "Cash" || item.payment_method === "نقد")
    ) {
      Cash = item?.amount;
      Change = receiptData.order[0].order_value.toFixed(2);
      console.log("4");
    }
    if (
      item?.name == "" &&
      (item?.payment_method == "Cash" || item?.payment_method == "نقد")
    ) {
      Cash = item?.amount;
      Change = (Cash - receiptData.order[0].order_value).toFixed(2);
      console.log("5");
    }
    if (
      item?.name == false &&
      (item?.payment_method == "Cash" || item?.payment_method == "نقد") &&
      item?.amount === 0.0
    ) {
      Cash = item?.amount;
      Change = 0;
      console.log("6");
    }
  });

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        const receiptContainer = document.querySelector(".custom-scrollbar");
        if (receiptContainer) {
          if (event.key === "ArrowUp") {
            receiptContainer.scrollTop -= 40; // adjust the scroll amount as needed
          } else if (event.key === "ArrowDown") {
            receiptContainer.scrollTop += 40; // adjust the scroll amount as needed
          }
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const hasBankPayment = receiptData?.order[0]?.payment_data.some(
    (payment) =>
      payment.payment_method === "Bank" || payment.payment_method === "بنك"
  );
  const hasCashPayment = receiptData?.order[0]?.payment_data.some(
    (payment) =>
      payment.payment_method === "Cash" || payment.payment_method === "نقد"
  );

  // console.log("PAYMEN", Cash);

  return (
    <div className="flex flex-col text-center w-[35%] max-md:ml-0 max-md:w-full h-full">
      <div className="fixed flex flex-col grow px-2 bg-white border border-solid border-stone-300 max-md:px-3 max-md:mt-10 max-md:max-w-full h-full">
        <div className="overflow-y-auto custom-scrollbar mb-20 mt-2 px-8">
          <div className="flex text-center items-center justify-center">
            <img
              src={receiptData?.order[0]?.compan_add.logo}
              alt="Store Logo"
              width="125"
            />
          </div>
          <div className="">
            {i18n.language == "ar"
              ? userData?.company_name_ar
              : userData?.company_name}
          </div>
          <div className="">
            {receiptData?.order[0]?.compan_add?.street &&
              receiptData?.order[0]?.compan_add?.street + ", "}
            {receiptData?.order[0]?.compan_add?.street2 &&
              receiptData?.order[0]?.compan_add?.street2 + ", "}
            {receiptData?.order[0]?.compan_add?.city &&
              receiptData?.order[0]?.compan_add?.city + ", "}
            {receiptData?.order[0]?.compan_add?.state &&
              receiptData?.order[0]?.compan_add?.state + ", "}
            {receiptData?.order[0]?.compan_add?.country &&
              receiptData?.order[0]?.compan_add?.country}
          </div>
          <div className="">
            {i18n.language == "ar" ? "" : "+20 "}
            {receiptData?.order[0]?.receipt_mobile_number && receiptData?.order[0]?.receipt_mobile_number != '' ? receiptData?.order[0]?.receipt_mobile_number : receiptData?.order[0]?.compan_add.tel}{" "}
            {i18n.language == "ar" ? " 20+" : ""}
          </div>

          <div className="text-center font-bold py-2 text-lg">
            {t("Receipt")}
          </div>

          <div className="border-y-2 border-dashed border-black py-2">
            <div className="flex justify-between ">
              <strong>{t("Order Number:")}</strong>
              <span>{receiptData?.order[0]?.order_no}</span>
            </div>
            <div className="flex justify-between ">
              <strong>{t("Order Date:")}</strong>
              <span>{receiptData?.order[0]?.date}</span>
            </div>
            <div className="flex justify-between ">
              <strong>{t("Cashier Name:")}</strong>
              <span>{receiptData?.order[0]?.cashier}</span>
            </div>
            {receiptData?.order[0]?.show_salesman && receiptData?.order[0]?.salesman && receiptData?.order[0]?.salesman != '' && 
             <div className="flex justify-between ">
              <strong>{t("Salesman Name:")}</strong>
              <span>{receiptData?.order[0]?.salesman}</span>
            </div>
            }
 
            <div className="flex justify-between ">
              <strong>{t("Payment Method:")}</strong>
              <span>
                {[
                  ...new Set(
                    receiptData?.order[0]?.payment_data.map((payment) =>
                      t(payment.payment_method)
                    )
                  ),
                ].join(" & ")}
              </span>
            </div>
            {/* {receiptData?.order[0]?.customer !== false &&
            receiptData?.order[0]?.customer_mobile !== false ? (
              <>
                <div className="flex justify-between ">
                  <strong>{t("Customer Name:")}</strong>
                  <span>
                    {receiptData?.order[0]?.customer ===
                    receiptData?.order[0]?.customer_mobile
                      ? "--"
                      : receiptData?.order[0]?.customer}
                  </span>
                </div>
                <div className="flex justify-between ">
                  <strong>{t("Customer Phone No.:")}</strong>
                  <span>{receiptData?.order[0]?.customer_mobile}</span>
                </div>
              </>
            ) : null} */}

            {receiptData?.order[0]?.customer !== false &&
              receiptData?.order[0]?.customer_mobile !== false ? (
              <>
                <div className="flex justify-between ">
                  <strong>{t("Customer Name:")}</strong>
                  <span>
                    {receiptData?.order[0]?.customer ===
                      receiptData?.order[0]?.customer_mobile
                      ? "--"
                      : receiptData?.order[0]?.customer}
                  </span>
                </div>

                {(receiptData?.order[0]?.order_status === "draft" &&
                  receiptData?.order[0]?.customer_mobile !== false) ||
                  !receiptData?.order[0]?.payment_data.some(
                    (payment) => payment.payment_method === "Bank"
                  ) ? (
                  <div className="flex justify-between ">
                    <strong>{t("Customer Phone No.:")}</strong>
                    <span>{receiptData?.order[0]?.customer_mobile}</span>
                  </div>
                ) : null}
              </>
            ) : null}

            {(receiptData?.order[0]?.order_status === "draft" &&
              receiptData?.order[0]?.customer_address?.length > 0 &&
              !receiptData?.order[0]?.payment_data.some(
                (payment) => payment.payment_method === "Bank"
              )) ||
              (receiptData?.order[0]?.order_value < 0 &&
                receiptData?.order[0]?.customer_address?.length > 0 &&
                !receiptData?.order[0]?.payment_data.some(
                  (payment) => payment.payment_method === "Bank"
                )) ? (
              <>
                <div className="flex justify-between flex-row w-full">
                  <strong>{t("Address")}:</strong>

                  <span
                    className={`flex text-wrap ${receiptData?.order[0]?.payment_data.some(
                      (payment) => payment.payment_method === "COD"
                    ) ? "font-semibold text-lg" : ""
                      }`}
                  >
                    {receiptData?.order[0]?.customer_address.map(
                      (address, index) => (
                        <div key={index}>
                          {address.add_field_1 && (
                            <span>
                              {/* <strong>Villa No. </strong> */}
                              {address.name === "Villa"
                                ? t("Villa No.-")
                                : address.name === "Apartment"
                                  ? t("Building-")
                                  : address.name === "Office"
                                    ? t("Company-")
                                    : ""}{" "}
                              {address.add_field_1},{" "}
                            </span>
                          )}
                          {address.add_field_2 && (
                            <span>
                              {/* <strong>Group No. </strong> */}
                              {/* {address.add_field_2},{" "} */}
                              {address.name === "Villa"
                                ? t("Group No.-")
                                : address.name === "Apartment"
                                  ? t("Apartment No.-")
                                  : address.name === "Office"
                                    ? t("Floor-")
                                    : ""}{" "}
                              {address.add_field_2},{" "}
                            </span>
                          )}
                          <br></br>
                          {address.add_field_3 && (
                            <span>
                              {/* <strong>Street </strong>
                              {address.add_field_3},{" "} */}
                              {address.name === "Villa"
                                ? t("Street-")
                                : address.name === "Apartment"
                                  ? t("Floor-")
                                  : address.name === "Office"
                                    ? t("Building-")
                                    : ""}{" "}
                              {address.add_field_3},{" "}
                            </span>
                          )}
                          {address.add_field_4 && (
                            <span>{address.add_field_4}</span>
                          )}
                        </div>
                      )
                    )}
                  </span>
                </div>
              </>
            ) : null}
          </div>

      <table className="w-full mt-4 text-sm table-fixed">
  <thead className="">
    <tr className="w-full">
      <th className="px-4 text-center w-[40%]">{t("Item")}</th>
 
      <th className={`text-center ${isETAenabled ? 'w-[10%]' : 'w-[15%]'}`}>{t("Qty")}</th>
 
      <th className={`text-center px-4 ${isETAenabled ? 'w-[20%]' : 'w-[25%]'}`}>
        {t("Unit Price")}
      </th>
 
      {isETAenabled && (
        <th className="text-right pe-3 w-[10%]">{t("Tax %")}</th>
      )}
 
      <th className="text-right w-[20%]">{t("Amount")}</th>
    </tr>
  </thead>
 
  <tbody>{renderProductLines()}</tbody>
</table>
          {/* </div> */}
          <div className="border-t-2 border-dashed border-black"></div>
          {/* {receiptData?.order[0]?.order_status === "draft" && ( */}
          {receiptData?.order[0]?.delivery_fee > 0 && (
            <div className=" flex justify-between py-2 mt-4">
              <strong>{t("Delivery Fee")}</strong>
              <span>
                EGP {Number(receiptData?.order[0]?.delivery_fee).toFixed(2)}
              </span>
            </div>
          )}

          {receiptData?.order[0]?.order_ref.includes("REFUND") &&
            receiptData?.order[0]?.return_delivery_fee > 0 ? (
            <div className="flex justify-between py-2">
              <strong>${t("Refunded Delivery Fee")}</strong>

              <span>
                EGP $
                {Number(receiptData?.order[0]?.return_delivery_fee).toFixed(2)}
              </span>
            </div>
          ) : receiptData?.order[0]?.return_delivery_fee < 0 ? (
            <div className="flex justify-between py-2">
              <strong>{t("Refunded Delivery Fee")}</strong>

              <span>
                EGP{" "}
                {Number(receiptData?.order[0]?.return_delivery_fee).toFixed(2)}
              </span>
            </div>
          ) : (
            ""
          )}

          <div className="flex justify-between py-2">
            <strong>{t("Total")}</strong>
            <span>
              EGP {(Number(receiptData?.order[0]?.order_value) + Number(receiptData?.order[0]?.total_discount)).toFixed(2)}
            </span>
            {/* <span>EGP {receiptData?.order[0]?.order_value}</span> */}
          </div>

          {receiptData?.order[0]?.total_discount > 0  && (
            <div className="flex justify-between py-2">
              <strong>{t("Total Discount")}</strong>
              <span>
                EGP {Number(receiptData?.order[0]?.total_discount).toFixed(2)}
              </span>
              {/* <span>EGP {receiptData?.order[0]?.order_value}</span> */}
            </div>
          )}

          {receiptData?.order[0]?.total_discount > 0 &&(
            <div className="flex justify-between py-2">
              <strong>{t("Grand Total")}</strong>
              <span>
                EGP {(Number(receiptData?.order[0]?.order_value).toFixed(2))}
              </span>
              {/* <span>EGP {receiptData?.order[0]?.order_value}</span> */}
            </div>
          )}

          {/* {receiptData?.order[0]?.payment_data.length === 2 && receiptData?.order[0]?.payment_data.name === false ? ( */}
          {/* {hasBankPayment && hasCashPayment ? (
            <div className="flex flex-col ">
              {receiptData?.order[0]?.payment_data.map((payment, index) => (
                <div className="flex justify-between py-2" key={index}>
                  <strong>{t(payment.payment_method)}</strong>
                  <span>EGP {Number(payment.amount).toFixed(2)}</span>
                </div>
              ))}
            </div>
          ) : (
            <>
              <div className="flex justify-between py-2">
                <strong>
                  {t(receiptData?.order[0]?.payment_data[0]?.payment_method)}
                  {console.log(
                    "SJSJSJS",
                    receiptData?.order[0]?.payment_data[0]
                  )}
                </strong>
                <span>
                  EGP{" "}
                  {Cash
                    ? Number(Cash).toFixed(2)
                    : receiptData?.order[0]?.payment_data[0]?.amount?.toFixed(
                        2
                      )}
                </span>
              </div>

              <div className="flex justify-between py-2">
                <strong>{t("Change")}</strong>
                <span>EGP {Number(Change).toFixed(2)}</span>
              </div>
            </>
          )} */}

          {hasCashPayment ? (
            <div className="flex flex-col ">
  {receiptData?.order[0]?.payment_data
    ?.filter((payment) => payment.name != 'return')
    .map((payment, index) => (
      <div className="flex justify-between py-2" key={index}>
        <strong>
          {t("Paid By")} {t(payment.payment_method)}
        </strong>
        <span>EGP {Number(payment.amount).toFixed(2)}</span>
      </div>
    ))}
</div>
          ) : (
            <>
              <div className="flex justify-between py-2">
                <strong>
                  {t("Paid By")}{" "}
                  {t(receiptData?.order[0]?.payment_data[0]?.payment_method)}
                </strong>
                <span>
                  EGP{" "}
                  {Cash
                    ? Number(Cash).toFixed(2)
                    : receiptData?.order[0]?.payment_data[0]?.amount?.toFixed(
                      2
                    )}
                </span>
              </div>
            </>
          )}
          {Change > 0 && (
            <div className="flex justify-between py-2">
              <strong>{t("Change")}</strong>
              <span>EGP {Number(Change - (isReturnOrder ? receiptData?.order[0]?.total_discount : 0)).toFixed(2)}</span>
            </div>
          )}

          {/* <div className="flex justify-between py-2">
            <strong>
              {t(receiptData?.order[0]?.payment_data[0]?.payment_method)}
            </strong>
            <span>EGP {Number(Cash).toFixed(2)}</span>
          </div>
          <div className="flex justify-between py-2">
            <strong>{t("Change")}</strong>
            <span>EGP {Number(Change).toFixed(2)}</span>
            {/* <span>EGP {Change}</span> */}

          <div className="w-full my-4 items-center justify-center flex">
            <img
              src={`https://barcode.tec-it.com/barcode.ashx?data=${order_idChange}&code=Code39&translate-esc=on`}
              alt="Receipt Barcode"
              // className=' self-center h-20 object-fit'
              width={"90%"}
            />
          </div>

          <div className="text-center border-t-2 border-dashed border-black mt-10 text-lg pt-4">
            {t("Your Technology Partner")}
            <br />
            <img
              // src="https://live-production-asset.s3.me-central-1.amazonaws.com/myginne.webp"
               src="https://assets.myginne.com/assets/lahloob_prod/RecieptLogo.jpeg"
              alt="Hisabak Logo"
              width="150"
              className="mx-auto"
            />
          </div>
          <div className="flex justify-center mt-3">
            <strong>{receiptData?.order[0]?.pos_receipt_custom_msg}</strong>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderReceipt;
